import {createContext, useContext, useMemo, useState} from 'react';
import AntDataGrid from "../../shared/components/AntDataGrid";
import ReactExport from '@ibrahimrahmani/react-export-excel'
import {Button, Toolbar, Typography, Avatar, Grid, TextField, Stack} from "@mui/material";
import {isNotEmpty} from "../../shared/functions/types_check";
import {uniqBy} from "lodash";
import {searchList} from "../../utils/array";
import useToggle from "../../shared/functions/useToggle";
import UpdateReceivingItem from './UpdateReceivingItem'
import DeleteDialog from './DeleteDialog';
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import FilterListIcon from "@material-ui/icons/FilterList";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


const columns = [
    {
        dataIndex: 'ItemName', title: 'Nom Produit',
        render: (_, record) => {
            const textMaxSize = text => text?.length > 100 ? text.substring(0, 19) + '...' : text;
            return (
                <Grid container>
                    <Grid item>
                        {record.ItemImageUrl ?
                            <Avatar alt={record.ItemName} src={record.ItemImageUrl}/> :
                            <Avatar>no</Avatar>}
                    </Grid>
                    <Grid item style={{marginTop: 12, marginLeft: 10}}>
                        {textMaxSize(record.ItemName)}
                    </Grid>
                </Grid>
            )
        }
    },
    {dataIndex: 'ItemBarcode', title: 'Code Barre'},
    {dataIndex: 'InternalId', title: 'Prosoft Code'},
    {dataIndex: 'Quantity', title: 'Déja Compté'},
    {dataIndex: 'QuantityForDekon', title: 'Qté Dekon'},
    {dataIndex: 'SellPrice', title: 'Prix de Vente'},
    {dataIndex: 'HasChilds', title: ' Pack'},
    {dataIndex: 'Threshold', title: 'seuil'},
    {dataIndex: 'ExpirationDate', title: 'Date Expiration'},
];

const ReceivingContext = createContext(null);

const useReceivingContext = () => useContext(ReceivingContext);

const ReceiviedItemDataGridContext = createContext()

export function useReceivedItemDataGridContext() {
    return useContext(ReceiviedItemDataGridContext)
}

function EnhancedTableHead({numSelected, selectedItem}) {
    const {keyword, setKeyword, rows} = useReceivingContext();
    const {open: updateOpen, handleOpen: handleOpenUpdate, handleClose: closeUpdateReceiving} = useToggle();
    const {open: deleteOpen, handleOpen: handleOpenDelete, handleClose: closeDeleteReceivingItems} = useToggle();

    return (
        <section style={{marginBottom: 10, marginTop: 10,}}>

            <TextField
                value={keyword}
                label={"Rechercher par nom, code barre, prosoft id"}
                variant={"outlined"}
                onChange={({target: {value}}) => setKeyword(value)}
                style={{
                    width: 500,
                    marginBottom: 10
                }}
            />

            {updateOpen && <UpdateReceivingItem closeUpdateReceiving={closeUpdateReceiving}
                                                updateItem={selectedItem} updateOpen={updateOpen}/>
            }

            {deleteOpen && <DeleteDialog open={deleteOpen} handleClose={closeDeleteReceivingItems}
                                         items={selectedItem}/>
            }

            {
                isNotEmpty(selectedItem) && (
                    <Toolbar style={{borderRadius: 20, backgroundColor: isNotEmpty(selectedItem) && '#eaecf7'}}>

                        <Grid container justifyContent={'space-between'} style={{paddingLeft: 20, paddingRight: 20}}>
                            <Grid>
                                <Typography variant={'h6'}>
                                    {`Séléctionnés :  ${numSelected}`}
                                </Typography>
                            </Grid>
                            <Stack direction={'row'} justifyContent={'end'}>
                                <Grid>
                                    <ExcelFile element={
                                        <Button style={{
                                            backgroundColor: "green",
                                            color: "white",
                                            borderRadius: 20,
                                            padding: 7
                                        }}>
                                            Exporter en excel
                                        </Button>
                                    }
                                    >
                                        <ExcelSheet data={selectedItem} name="Reciving">
                                            <ExcelColumn label="Code article" value="InternalId"/>
                                            <ExcelColumn label="Référence" value=""/>
                                            <ExcelColumn label="Code barre" value="ItemBarcode"/>
                                            <ExcelColumn label="Nom article" value="ItemName"/>
                                            <ExcelColumn label="Description" value="ItemName"/>
                                            <ExcelColumn label="Qté achat" value="Quantity"/>
                                            <ExcelColumn label="Prix achat" value="Price"/>
                                            <ExcelColumn label="Prix de vente" value="SellPrice"/>
                                            <ExcelColumn label="Pack" value="HasChilds"/>
                                            <ExcelColumn label="Classe" value="ItemClsass"/>
                                            <ExcelColumn label="Seuil réaprovisionnement" value="Threshold"/>
                                            <ExcelColumn label="N° Lot" value="ExpirationDate"/>
                                            <ExcelColumn label="Date expiration" value="ExpirationDate"/>
                                        </ExcelSheet>
                                    </ExcelFile>
                                </Grid>

                                <Grid>
                                    <ExcelFile element={
                                        <Button style={{
                                            backgroundColor: "green",
                                            color: "white",
                                            borderRadius: 20,
                                            padding: 7
                                        }}>
                                            Exporter Tout en excel
                                        </Button>
                                    }
                                    >
                                        <ExcelSheet data={rows} name="Reciving">
                                            <ExcelColumn label="id" value="id"/>
                                            <ExcelColumn label="Code article" value="InternalId"/>
                                            <ExcelColumn label="Référence" value=""/>
                                            <ExcelColumn label="Code barre" value="ItemBarcode"/>
                                            <ExcelColumn label="Nom article" value="ItemName"/>
                                            <ExcelColumn label="Description" value="ItemName"/>
                                            <ExcelColumn label="Qté achat" value="Quantity"/>
                                            <ExcelColumn label="Prix achat" value="Price"/>
                                            <ExcelColumn label="Prix de vente" value="SellPrice"/>
                                            <ExcelColumn label="Pack" value="HasChilds"/>
                                            <ExcelColumn label="Classe" value="ItemClsass"/>
                                            <ExcelColumn label="Seuil réaprovisionnement" value="Threshold"/>
                                            <ExcelColumn label="N° Lot" value="ExpirationDate"/>
                                            <ExcelColumn label="Date expiration" value="ExpirationDate"/>
                                        </ExcelSheet>
                                    </ExcelFile>
                                </Grid>
                            </Stack>
                        </Grid>

                        {numSelected > 0 ? (
                            numSelected === 1 ? (
                                <>
                                    <Tooltip title="editer" placement="top">
                                        <IconButton aria-label="delete" color="primary" onClick={handleOpenUpdate}>
                                            <EditIcon/>
                                        </IconButton>
                                    </Tooltip>
                                    <div style={{marginLeft: 30}}/>
                                    <Tooltip title="supprimer" placement="top">
                                        <IconButton aria-label="delete" color="secondary"
                                                    onClick={handleOpenDelete}>
                                            <DeleteIcon/>
                                        </IconButton>
                                    </Tooltip>
                                </>
                            ) : (
                                <Tooltip title="Delete" placement="top">
                                    <IconButton aria-label="delete" color="secondary" onClick={handleOpenDelete}>
                                        <DeleteIcon/>
                                    </IconButton>
                                </Tooltip>)
                        ) : (
                            <Tooltip title="Filter list">
                                <IconButton aria-label="filter list">
                                    <FilterListIcon/>
                                </IconButton>
                            </Tooltip>
                        )}
                    </Toolbar>

                )
            }
        </section>
    )
}

const filterList = (collection, keyword) => {
    return uniqBy([
        ...searchList(collection, keyword, 'ItemName'),
        ...searchList(collection, keyword, 'InternalId'),
        ...searchList(collection, keyword, 'ItemBarcode'),
    ], 'id')
}

export default function ReceivedDetailsItemDataGrid({receiving = [], receivingId, closeDetail}) {
    const [keyword, setKeyword] = useState('');
    const rows = useMemo(() => receiving?.map(one => ({
        ...one,
        id: one?.ItemId,
        key: one?.ItemId,
        ExpirationDate: one?.ExpirationDate?.toDate() || null
    })) || [], [receiving]);
    const filtered = useMemo(() => filterList(rows, keyword), [rows, keyword])


    return (
        <ReceiviedItemDataGridContext.Provider
            value={{items: rows, receivingId: receivingId, closeDetail: closeDetail}}
        >
            <ReceivingContext.Provider value={{keyword, setKeyword, rows}}>
                <AntDataGrid
                    columns={columns}
                    ToolBar={EnhancedTableHead}
                    data={filtered}
                />
            </ReceivingContext.Provider>
        </ReceiviedItemDataGridContext.Provider>
    );
}
